import React, { useRef } from "react";
import { WEDDING } from "../utils/config";
import { useTilt } from "../hooks/useTilt";
export default function Bio() {
  const r1 = useRef(null);
  useTilt(r1, 6);
  const r2 = useRef(null);
  useTilt(r2, 6);
  return (
    <section
      id="bio"
      style={{ background: "var(--mint-p)", padding: "96px 36px" }}
    >
      <div style={{ maxWidth: "960px", margin: "0 auto" }}>
        <div
          className="reveal"
          style={{ textAlign: "center", marginBottom: "44px" }}
        >
          <div
            className="section-tag"
            style={{ justifyContent: "center", display: "flex" }}
          >
            Meet the Couple
          </div>
          <h2 className="section-title">
            The hearts <em>behind</em> the love
          </h2>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
          }}
          className="grid-2-mobile"
        >
          {[
            {
              ref: r1,
              name: WEDDING.groomName + " " + WEDDING.surnamegroom,
              role: "The Groom",
              av: "linear-gradient(135deg,var(--sage-p),var(--mint-l))",
              ac: "var(--forest)",
              text: WEDDING.groomBio,
            },
            {
              ref: r2,
              name: WEDDING.brideName + " " + WEDDING.surnamebride,
              role: "The Bride",
              av: "linear-gradient(135deg,var(--mint-l),var(--sage))",
              ac: "var(--deep)",
              text: WEDDING.brideBio,
            },
          ].map((p, i) => (
            <div
              key={i}
              ref={p.ref}
              className="tilt-card bio-card reveal"
              style={{
                background: "#fff",
                border: ".5px solid var(--sage-p)",
                borderRadius: "10px",
                padding: "38px 30px",
                textAlign: "center",
                boxShadow: "0 2px 12px rgba(36,60,40,.06)",
              }}
            >
              <div
                style={{
                  width: "84px",
                  height: "84px",
                  borderRadius: "50%",
                  margin: "0 auto 18px",
                  padding: "2px",
                  position: "relative",
                }}
              >
                <div
                  className="ring-spin"
                  style={{
                    position: "absolute",
                    inset: 0,
                    borderRadius: "50%",
                    background:
                      "conic-gradient(var(--sage),var(--mint),var(--gold),var(--sage))",
                  }}
                />
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    background: p.av,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "var(--font-serif)",
                    fontSize: "27px",
                    fontWeight: 300,
                    color: p.ac,
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  M&O
                </div>
              </div>
              <div
                style={{
                  fontFamily: "var(--font-serif)",
                  fontSize: "26px",
                  marginBottom: "3px",
                }}
              >
                {p.name}
              </div>
              <div
                style={{
                  fontSize: "8px",
                  letterSpacing: ".2em",
                  textTransform: "uppercase",
                  color: "var(--gold)",
                  marginBottom: "14px",
                }}
              >
                {p.role}
              </div>
              <p
                style={{
                  fontSize: "13px",
                  lineHeight: 1.9,
                  color: "var(--muted)",
                }}
              >
                {p.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
